import template from './mycrmSelectDateRange.html';
import controller from './mycrmSelectDateRangeCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    dateRangeOptions: '<',
    defaultIndex: '<',
    onChange: '&',
  },
};
